import { Editor, EditorOptions } from 'tinymce';

import { ExternalMergeTag } from '../core/Types';

const isObjectArray = (value: unknown): boolean =>
  Array.isArray(value) &&
  value.every(
    (item) => typeof item === 'object' && item !== null && !Array.isArray(item)
  );

const option: {
  <K extends keyof EditorOptions>(
    name: K
  ): (editor: Editor) => EditorOptions[K];
  <T>(name: string): (editor: Editor) => T;
} = (name: string) => (editor: Editor) => editor.options.get(name);

const register = (editor: Editor): void => {
  const registerOption = editor.options.register;

  registerOption('mergetags_list', {
    processor: isObjectArray,
    default: [],
  });
};

const getMergeTags = option<ExternalMergeTag[]>('mergetags_list');

export { getMergeTags, register };
